var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sort-item"},[(_vm.type === _vm.fileType.IMAGE)?_c('img',{attrs:{"src":_vm.url,"alt":"href"}}):(_vm.type === _vm.fileType.VIDEO)?_c('video',[_c('source',{attrs:{"src":_vm.url}})]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }